// extracted by mini-css-extract-plugin
export default {"header":"ProductTable_header__vhthV","body":"ProductTable_body__Csiwp"};